import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { formatText } from "../../../utils/quiz-parser.js";
import { substituteVariables } from "../../../utils/textFormatter.js";
import { getImageUrl, PrintQuizImage } from "./print-common.js";
const toImg = (c) => c ? { signedUrl: c.signedUrl ?? void 0, url: c.url ?? void 0 } : null;
function PrintQuizDescription({
  description,
  commentaryImages,
  vars,
  hideLabel,
  compact
}) {
  const rawText = description == null ? void 0 : description.text;
  const descImageUrl = getImageUrl(toImg(description == null ? void 0 : description.image), toImg(description == null ? void 0 : description.imagePrint));
  if (!rawText && !descImageUrl) return null;
  const text = rawText && vars && Object.keys(vars).length > 0 ? substituteVariables(rawText, vars) : rawText;
  const body = /* @__PURE__ */ jsxs(Fragment, { children: [
    text && /* @__PURE__ */ jsx("div", { className: compact ? "text-[13px] leading-[1.6] text-gray-700" : "text-[15px] leading-[1.7] text-gray-700", children: formatText(text, "print-desc", commentaryImages ?? void 0) }),
    descImageUrl && /* @__PURE__ */ jsx(PrintQuizImage, { src: descImageUrl, alt: "explanation", className: "mt-[8px]" })
  ] });
  if (hideLabel) {
    return /* @__PURE__ */ jsx("div", { className: "break-inside-avoid", children: body });
  }
  return /* @__PURE__ */ jsxs("div", { className: "break-inside-avoid mt-[12px] px-[40px]", children: [
    /* @__PURE__ */ jsx("div", { className: compact ? "text-[12px] font-bold text-gray-500 mb-[2px]" : "text-[14px] font-bold text-gray-500 mb-[4px]", children: "해설" }),
    body
  ] });
}
export {
  PrintQuizDescription
};
//# sourceMappingURL=print-quiz-description.js.map
